<div class="u-flex u-items-center u-mt-3 u-mb-2">

    <div *ngIf="showAddButton">
      <div class="u-mr-2" [pTooltip]="addButtonTooltip">
        <button pButton 
        type="button" 
        [disabled]="disableAddButton" 
        icon="ui-icon-add"
        class="fab primaryAction" 
        (click)=onClickAddButton($event)></button>
      </div>
    </div>
  
    <div class="u-flex u-justify-between u-flex-1 u-flex-wrap u-pb-2 u-border-b u-border-solid u-border-primary">
      <div class="u-flex u-items-center">
  
        <i *ngIf="icon" 
        [class]="icon"
         aria-hidden="true" 
         class="u-text-xxxl u-mr-2"></i>
  
        <i class="u-txt-xxxl u-mr-2" 
        *ngIf="iconConfig" 
        [ngClass]="iconConfig?.cssClasses">
          {{ iconConfig?.name }}
        </i>
  
        <span class="u-flex-nowrap u-overflow-hidden u-text-xxxl u-font-medium u-overflow-ellipsis" data-cy="content-header-title">{{ title }}</span>
  
      </div>
  
      <div class="u-flex-grow-1 u-flex-shrink-0">
        <div *ngIf="!!showCalendar" 
        class="al-calender u-flex u-justify-end">
          <p-calendar #datePicker 
          *ngIf="showCalendar !== 'al-date-range-selector'" 
          selectionMode="{{showCalendar}}"
          [(ngModel)]="dateRange" 
          [placeholder]="dateTimePlaceholder" 
          (onFocus)="toggleSelectorVisibility()"
          (onClose)="toggleSelectorVisibility()" 
          (onSelect)="selectedSingleDate()" 
          [showIcon]="true"
          [icon]="showDateSelector ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
          dateFormat="d M yy"
          [showTime]="showTime" 
          hourFormat="24">
            <p-footer>
              <div class="btnGroupRight">
                <button pButton 
                type="button" 
                label="Cancel" 
                class="btnSmall flat" 
                (click)="close()">
                </button>
                <button pButton 
                type="button" 
                label="Apply" 
                class="btnSmall primaryAction" 
                (click)="selectedDateRange()">
                </button>
              </div>
            </p-footer>
          </p-calendar>
          <span *ngIf="dateRange && showCalendar !== 'al-date-range-selector'">
            <i class="material-icons" 
            *ngIf="dateRange" 
            (click)="clear()">close</i>
          </span>
          <al-date-range-selector #alDateSelector 
          *ngIf="showCalendar === 'al-date-range-selector'"
            [initialDateRangeSelection]="initialDateRangeSelection" 
            [fixedRanges]="defaultFixedRanges"
            [showTimePicker]="showTimePicker" 
            [returnTimeFrame]="returnTimeFrame" 
            [placeholder]="placeholder"
            [selectorTitle]="selectorTitle" 
            [customRangeTitle]="customRangeTitle" 
            [calendarMaxDate]="calendarMaxDate"
            [calendarMinDate]="calendarMinDate" 
            (onDateSelected)="dateRangeSelectedFromAlDateRangeSelector($event)"
            (onClosedCalendar)="closedAlDateRangeSelector($event)" 
            (onShowCalendar)="showAlDateRangeSelector($event)"
            (onSelectFixedRange)="selectFixedRangeAlDateRangeSelector($event)">
          </al-date-range-selector>
        </div>
      </div>
    </div>
  </div>
  
  <div class="u-text-sm" 
  *ngIf="descriptionHeader" 
  [innerHTML]="descriptionHeader"></div>
